module.exports = __webpack_public_path__ + "static/media/quiz_female_icon.c4da1a35.svg";